import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Nav, Container, Card } from "react-bootstrap";
import EnquiryLogPage from "./EnquiryLog"; // Assume you create these
import EnquiryJunkPage from "./EnquiryJunk"; // Assume you create these
import EnquiryDraftPage from "./EnquiryDraft"; // The component you provided

// Define the valid tab types
type TabType = "log" | "junk" | "draft";

// Map the URL param to a more readable type for the component
const tabMap: Record<string, TabType> = {
  enquiry_log: "log",
  junk: "junk",
  draft: "draft",
};

const ServiceEnquiryPage: React.FC = () => {
  // Use useParams to get the 'tab' dynamic segment from the route
  const { tab: urlTabParam } = useParams<{ tab: string }>();
  const type: "service" = "service"; // The type is fixed for this page

  // Determine the active tab based on the URL param
  const activeTab: TabType = tabMap[urlTabParam || "enquiry_log"] || "log";

  


  // Determine which component to render
  const TabContent = useMemo(() => {
    // Pass the fixed 'type' prop to all tab components
    switch (activeTab) {
      case "log":
        return <EnquiryLogPage type={type} />;
      case "junk":
        return <EnquiryJunkPage type={type} />;
      case "draft":
        return <EnquiryDraftPage type={type} />;
      default:
        // Render the log page as default/fallback
        return <EnquiryLogPage type={type} />;
    }
  }, [activeTab]);

  return (<>
  {TabContent}
  </>
 
  );
};

export default ServiceEnquiryPage;
